// ----------------------------------------------------------------------
// <copyright file="Izenda.List.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module List component
 * @example
 *  <List>
      <p>Item 1</p>
      <p>Item 2</p>
 *  </List>
 */
!(function() {
  var React = require('react');
  const { omit } = require('lodash/fp');
  var List = React.createClass({
    propTypes: {
      itemClass: React.PropTypes.string
    },
    /**
     * Render component
     * @returns {type}
     */
    render: function() {
      var props = this.props;

      var items = this.props.children.map(function(item, index) {
        return (
          <li className={props.itemClass} key={index}>
            {item}
          </li>
        );
      });

      var rest = omit(['children', 'itemClass'], this.props);

      return <ul {...rest}>{items}</ul>;
    }
  });

  module.exports = List;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.List.jsx